import { useCallback } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import type { PcmpReportSearch } from '../types/pcmpReports.types';
import { usePcmpReportFilters } from './usePcmpReportFilters';

const route = getRouteApi('/_auth/pcmp/reports/performance/');

/** The Performance report's filters, which are the shared report filters alone. */
export function usePcmpPerformanceReportFilters() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const setSearch = useCallback(
    (update: (prev: PcmpReportSearch) => PcmpReportSearch) => {
      void navigate({ search: update });
    },
    [navigate],
  );

  return usePcmpReportFilters(search, setSearch);
}
